// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Alert = require("../common/Components/Alert.bs.js");
var React = require("react");
var ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Formality = require("../../vendor/re-formality/Formality.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Form__Input = require("../../uikit/reason/atoms/Form/Form__Input.bs.js");
var Form__Label = require("../../uikit/reason/atoms/Form/Form__Label.bs.js");
var FormalityUI = require("../common/Form/FormalityUI.bs.js");
var ReactRender = require("../../reason/utils/ReactRender.bs.js");
var UserSession = require("../../reason/common/UserSession/UserSession.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var Form__Helpers = require("../../reason/common/Form/Form__Helpers.bs.js");
var RichTextEditorV5 = require("../common/Components/RichTextEditorV5.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var Formality__ReactUpdate = require("../../vendor/re-formality/Formality__ReactUpdate.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
var EditMarketingProfileMemberInfoFormMutation_graphql = require("../../__generated__/EditMarketingProfileMemberInfoFormMutation_graphql.bs.js");
var EditMarketingProfileMemberInfoForm_marketingProfileMember_graphql = require("../../__generated__/EditMarketingProfileMemberInfoForm_marketingProfileMember_graphql.bs.js");

var validators_title = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (function (param) {
      var title = param.title;
      if (title === "") {
        return {
                TAG: "Error",
                _0: "IsRequired"
              };
      } else {
        return {
                TAG: "Ok",
                _0: title
              };
      }
    })
};

var validators_lastName = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (function (param) {
      var lastName = param.lastName;
      if (lastName === "") {
        return {
                TAG: "Error",
                _0: "IsRequired"
              };
      } else {
        return {
                TAG: "Ok",
                _0: lastName
              };
      }
    })
};

var validators_firstName = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (function (param) {
      var firstName = param.firstName;
      if (firstName === "") {
        return {
                TAG: "Error",
                _0: "IsRequired"
              };
      } else {
        return {
                TAG: "Ok",
                _0: firstName
              };
      }
    })
};

var validators = {
  bio: undefined,
  title: validators_title,
  licenseNumber: undefined,
  lastName: validators_lastName,
  firstName: validators_firstName
};

function initialFieldsStatuses(_input) {
  return {
          bio: "Pristine",
          title: "Pristine",
          licenseNumber: "Pristine",
          lastName: "Pristine",
          firstName: "Pristine"
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: initialFieldsStatuses(input),
          collectionsStatuses: undefined,
          formStatus: "Editing",
          submissionStatus: "NeverSubmitted"
        };
}

function validateForm(input, validators, fieldsStatuses) {
  var match_0 = {
    TAG: "Ok",
    _0: input.bio
  };
  var match = fieldsStatuses.title;
  var tmp;
  tmp = typeof match !== "object" ? validators.title.validate(input) : match._0;
  var match_0$1 = {
    TAG: "Ok",
    _0: input.licenseNumber
  };
  var match$1 = fieldsStatuses.lastName;
  var tmp$1;
  tmp$1 = typeof match$1 !== "object" ? validators.lastName.validate(input) : match$1._0;
  var match$2 = fieldsStatuses.firstName;
  var tmp$2;
  tmp$2 = typeof match$2 !== "object" ? validators.firstName.validate(input) : match$2._0;
  var bioResult = match_0;
  var bioResult$1;
  if (bioResult.TAG === "Ok") {
    var titleResult = tmp;
    if (titleResult.TAG === "Ok") {
      var licenseNumberResult = match_0$1;
      if (licenseNumberResult.TAG === "Ok") {
        var lastNameResult = tmp$1;
        if (lastNameResult.TAG === "Ok") {
          var firstNameResult = tmp$2;
          if (firstNameResult.TAG === "Ok") {
            return {
                    TAG: "Valid",
                    output: {
                      firstName: firstNameResult._0,
                      lastName: lastNameResult._0,
                      licenseNumber: licenseNumberResult._0,
                      title: titleResult._0,
                      bio: bioResult._0
                    },
                    fieldsStatuses: {
                      bio: {
                        TAG: "Dirty",
                        _0: bioResult,
                        _1: "Hidden"
                      },
                      title: {
                        TAG: "Dirty",
                        _0: titleResult,
                        _1: "Shown"
                      },
                      licenseNumber: {
                        TAG: "Dirty",
                        _0: licenseNumberResult,
                        _1: "Hidden"
                      },
                      lastName: {
                        TAG: "Dirty",
                        _0: lastNameResult,
                        _1: "Shown"
                      },
                      firstName: {
                        TAG: "Dirty",
                        _0: firstNameResult,
                        _1: "Shown"
                      }
                    },
                    collectionsStatuses: undefined
                  };
          }
          bioResult$1 = bioResult;
        } else {
          bioResult$1 = bioResult;
        }
      } else {
        bioResult$1 = bioResult;
      }
    } else {
      bioResult$1 = bioResult;
    }
  } else {
    bioResult$1 = bioResult;
  }
  return {
          TAG: "Invalid",
          fieldsStatuses: {
            bio: {
              TAG: "Dirty",
              _0: bioResult$1,
              _1: "Hidden"
            },
            title: {
              TAG: "Dirty",
              _0: tmp,
              _1: "Shown"
            },
            licenseNumber: {
              TAG: "Dirty",
              _0: match_0$1,
              _1: "Hidden"
            },
            lastName: {
              TAG: "Dirty",
              _0: tmp$1,
              _1: "Shown"
            },
            firstName: {
              TAG: "Dirty",
              _0: tmp$2,
              _1: "Shown"
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action !== "object") {
            switch (action) {
              case "BlurBioField" :
                  var result = Formality.validateFieldOnBlurWithoutValidator(state.input.bio, state.fieldsStatuses.bio, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  bio: status,
                                  title: init.title,
                                  licenseNumber: init.licenseNumber,
                                  lastName: init.lastName,
                                  firstName: init.firstName
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "BlurTitleField" :
                  var result$1 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.title, validators_title, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  bio: init.bio,
                                  title: status,
                                  licenseNumber: init.licenseNumber,
                                  lastName: init.lastName,
                                  firstName: init.firstName
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "BlurLicenseNumberField" :
                  var result$2 = Formality.validateFieldOnBlurWithoutValidator(state.input.licenseNumber, state.fieldsStatuses.licenseNumber, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  bio: init.bio,
                                  title: init.title,
                                  licenseNumber: status,
                                  lastName: init.lastName,
                                  firstName: init.firstName
                                };
                        }));
                  if (result$2 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "BlurLastNameField" :
                  var result$3 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.lastName, validators_lastName, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  bio: init.bio,
                                  title: init.title,
                                  licenseNumber: init.licenseNumber,
                                  lastName: status,
                                  firstName: init.firstName
                                };
                        }));
                  if (result$3 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$3,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "BlurFirstNameField" :
                  var result$4 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.firstName, validators_firstName, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  bio: init.bio,
                                  title: init.title,
                                  licenseNumber: init.licenseNumber,
                                  lastName: init.lastName,
                                  firstName: status
                                };
                        }));
                  if (result$4 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$4,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "Submit" :
                  var match = state.formStatus;
                  if (typeof match === "object" && match.TAG === "Submitting") {
                    return "NoUpdate";
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG !== "Valid") {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: "Editing",
                              submissionStatus: "AttemptedToSubmit"
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: "UpdateWithSideEffects",
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: "Submitting",
                              _0: tmp
                            },
                            submissionStatus: "AttemptedToSubmit"
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              onSubmit(output, {
                                    notifyOnSuccess: (function (input) {
                                        dispatch({
                                              TAG: "SetSubmittedStatus",
                                              _0: input
                                            });
                                      }),
                                    notifyOnFailure: (function (error) {
                                        dispatch({
                                              TAG: "SetSubmissionFailedStatus",
                                              _0: error
                                            });
                                      }),
                                    reset: (function () {
                                        dispatch("Reset");
                                      }),
                                    dismissSubmissionResult: (function () {
                                        dispatch("DismissSubmissionResult");
                                      })
                                  });
                            })
                        };
                  break;
              case "DismissSubmissionError" :
                  var match$2 = state.formStatus;
                  if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
                    return "NoUpdate";
                  } else {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Editing",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case "DismissSubmissionResult" :
                  var match$3 = state.formStatus;
                  if (typeof match$3 !== "object") {
                    if (match$3 === "Editing") {
                      return "NoUpdate";
                    }
                    
                  } else if (match$3.TAG === "Submitting") {
                    return "NoUpdate";
                  }
                  return {
                          TAG: "Update",
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: "Editing",
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "Reset" :
                  return {
                          TAG: "Update",
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG) {
              case "UpdateBioField" :
                  var nextInput = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput.bio, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            bio: status,
                                            title: init.title,
                                            licenseNumber: init.licenseNumber,
                                            lastName: init.lastName,
                                            firstName: init.firstName
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "UpdateTitleField" :
                  var nextInput$1 = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$1, state.fieldsStatuses.title, state.submissionStatus, validators_title, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            bio: init.bio,
                                            title: status,
                                            licenseNumber: init.licenseNumber,
                                            lastName: init.lastName,
                                            firstName: init.firstName
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "UpdateLicenseNumberField" :
                  var nextInput$2 = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$2.licenseNumber, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            bio: init.bio,
                                            title: init.title,
                                            licenseNumber: status,
                                            lastName: init.lastName,
                                            firstName: init.firstName
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "UpdateLastNameField" :
                  var nextInput$3 = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput$3,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$3, state.fieldsStatuses.lastName, state.submissionStatus, validators_lastName, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            bio: init.bio,
                                            title: init.title,
                                            licenseNumber: init.licenseNumber,
                                            lastName: status,
                                            firstName: init.firstName
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "UpdateFirstNameField" :
                  var nextInput$4 = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput$4,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$4, state.fieldsStatuses.firstName, state.submissionStatus, validators_firstName, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            bio: init.bio,
                                            title: init.title,
                                            licenseNumber: init.licenseNumber,
                                            lastName: init.lastName,
                                            firstName: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "SetSubmittedStatus" :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: input,
                              fieldsStatuses: initialFieldsStatuses(input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Submitted",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: initialFieldsStatuses(state.input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Submitted",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case "SetSubmissionFailedStatus" :
                  return {
                          TAG: "Update",
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: "SubmissionFailed",
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "MapSubmissionError" :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 !== "object") {
                    return "NoUpdate";
                  }
                  if (error$1.TAG !== "Submitting") {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: "SubmissionFailed",
                                _0: map(error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: "Submitting",
                                _0: Caml_option.some(map(Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 !== "object" || match$1.TAG !== "Submitting" ? false : true;
  return {
          updateBio: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateBioField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          updateTitle: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateTitleField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          updateLicenseNumber: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateLicenseNumberField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          updateLastName: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateLastNameField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          updateFirstName: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateFirstNameField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          blurBio: (function () {
              dispatch("BlurBioField");
            }),
          blurTitle: (function () {
              dispatch("BlurTitleField");
            }),
          blurLicenseNumber: (function () {
              dispatch("BlurLicenseNumberField");
            }),
          blurLastName: (function () {
              dispatch("BlurLastNameField");
            }),
          blurFirstName: (function () {
              dispatch("BlurFirstNameField");
            }),
          bioResult: Formality.exposeFieldResult(state.fieldsStatuses.bio),
          titleResult: Formality.exposeFieldResult(state.fieldsStatuses.title),
          licenseNumberResult: Formality.exposeFieldResult(state.fieldsStatuses.licenseNumber),
          lastNameResult: Formality.exposeFieldResult(state.fieldsStatuses.lastName),
          firstNameResult: Formality.exposeFieldResult(state.fieldsStatuses.firstName),
          input: state.input,
          status: state.formStatus,
          dirty: (function () {
              var match = state.fieldsStatuses;
              var tmp = match.bio;
              if (typeof tmp === "object") {
                return true;
              }
              var tmp$1 = match.title;
              if (typeof tmp$1 === "object") {
                return true;
              }
              var tmp$2 = match.licenseNumber;
              if (typeof tmp$2 === "object") {
                return true;
              }
              var tmp$3 = match.lastName;
              if (typeof tmp$3 === "object") {
                return true;
              }
              var tmp$4 = match.firstName;
              if (typeof tmp$4 !== "object") {
                return false;
              } else {
                return true;
              }
            }),
          valid: (function () {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG === "Valid") {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function () {
              dispatch("Submit");
            }),
          dismissSubmissionError: (function () {
              dispatch("DismissSubmissionError");
            }),
          dismissSubmissionResult: (function () {
              dispatch("DismissSubmissionResult");
            }),
          mapSubmissionError: (function (map) {
              dispatch({
                    TAG: "MapSubmissionError",
                    _0: map
                  });
            }),
          reset: (function () {
              dispatch("Reset");
            })
        };
}

var Config = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

var convertFragment = EditMarketingProfileMemberInfoForm_marketingProfileMember_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, EditMarketingProfileMemberInfoForm_marketingProfileMember_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(EditMarketingProfileMemberInfoForm_marketingProfileMember_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, EditMarketingProfileMemberInfoForm_marketingProfileMember_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(EditMarketingProfileMemberInfoForm_marketingProfileMember_graphql.node, convertFragment, fRef);
}

var Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

var convertVariables = EditMarketingProfileMemberInfoFormMutation_graphql.Internal.convertVariables;

var convertResponse = EditMarketingProfileMemberInfoFormMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse = EditMarketingProfileMemberInfoFormMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, EditMarketingProfileMemberInfoFormMutation_graphql.node, convertResponse, convertWrapRawResponse);

var use$1 = RescriptRelay_Mutation.useMutation(convertVariables, EditMarketingProfileMemberInfoFormMutation_graphql.node, convertResponse, convertWrapRawResponse);

var Mutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$1
};

function initialStateFromFragment(member) {
  return {
          firstName: member.firstName,
          lastName: member.lastName,
          licenseNumber: Core__Option.getOr(member.licenseNumber, ""),
          title: member.title,
          bio: member.bio
        };
}

function messageToString(v) {
  return "is required";
}

function EditMarketingProfileMemberInfoForm$FieldValidationMessage(props) {
  return JsxRuntime.jsx(FormalityUI.FieldValidationMessage.make, {
              messageToString: messageToString,
              result: props.result
            });
}

var FieldValidationMessage = {
  make: EditMarketingProfileMemberInfoForm$FieldValidationMessage
};

function EditMarketingProfileMemberInfoForm$InputField(props) {
  var status = props.status;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(Form__Label.make, {
                            labelText: props.labelText
                          }),
                      className: "pt-2"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(Form__Input.make, {
                              type: props._type,
                              onChange: props.onChange,
                              onBlur: props.onBlur,
                              status: FormalityUI.UIKitStatus.ofOptFieldResult(status),
                              value: props.value
                            }),
                        Core__Option.getOr(Core__Option.map(props.helpText, (function (text) {
                                    return JsxRuntime.jsx("div", {
                                                children: text,
                                                className: "text-base text-gray-500"
                                              });
                                  })), null),
                        JsxRuntime.jsx(EditMarketingProfileMemberInfoForm$FieldValidationMessage, {
                              result: status
                            })
                      ],
                      className: "mt-2 sm:col-span-2 sm:mt-0 sm:max-w-xs space-y-3"
                    })
              ],
              className: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6"
            });
}

var InputField = {
  make: EditMarketingProfileMemberInfoForm$InputField
};

function EditMarketingProfileMemberInfoForm$BioField(props) {
  var form = props.form;
  var initialBio = React.useRef(form.input.bio);
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(Form__Label.make, {
                            labelText: "Bio"
                          }),
                      className: "pt-2"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(RichTextEditorV5.make, {
                            initialContent: initialBio.current,
                            onChange: (function (value) {
                                form.updateBio((function (input, value) {
                                        return {
                                                firstName: input.firstName,
                                                lastName: input.lastName,
                                                licenseNumber: input.licenseNumber,
                                                title: input.title,
                                                bio: value
                                              };
                                      }), value);
                              }),
                            onBlur: (function (param) {
                                form.blurBio();
                              }),
                            toolbar: "withoutHeaders"
                          }),
                      className: "mt-2 sm:col-span-2 sm:mt-0 space-y-3"
                    })
              ],
              className: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6"
            });
}

var BioField = {
  make: EditMarketingProfileMemberInfoForm$BioField
};

function EditMarketingProfileMemberInfoForm(props) {
  var member = use(props.member);
  var match = use$1();
  var mutate = match[0];
  var form = useForm(initialStateFromFragment(member), (function (data, param) {
          var notifyOnFailure = param.notifyOnFailure;
          var notifyOnSuccess = param.notifyOnSuccess;
          mutate({
                input: {
                  bio: data.bio,
                  firstName: data.firstName,
                  lastName: data.lastName,
                  licenseNumber: Form__Helpers.opt_of_string(data.licenseNumber),
                  memberId: member.id,
                  title: data.title
                }
              }, undefined, undefined, undefined, (function (param, param$1) {
                  var result = param.updateMarketingProfileMemberInfo;
                  if (result !== undefined && result.__typename === "MarketingProfileMemberInfoUpdated") {
                    return notifyOnSuccess(undefined);
                  } else {
                    return notifyOnFailure();
                  }
                }), (function (param) {
                  notifyOnFailure();
                }), undefined);
        }));
  var hasFullProfile = UserSession.useHasPlanFeature("FULL_AGENT_PAGE");
  var match$1 = form.status;
  var tmp;
  var exit = 0;
  if (typeof match$1 !== "object") {
    if (match$1 === "Editing") {
      tmp = null;
    } else {
      exit = 1;
    }
  } else if (match$1.TAG === "Submitting") {
    exit = 1;
  } else {
    tmp = JsxRuntime.jsx(Alert.$$Error.make, {
          title: "There was an error updating " + member.firstName + "'s profile. Please try again"
        });
  }
  if (exit === 1) {
    tmp = JsxRuntime.jsx(Alert.Success.make, {
          title: member.firstName + "'s profile was updated"
        });
  }
  return JsxRuntime.jsxs("form", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(EditMarketingProfileMemberInfoForm$InputField, {
                              onChange: (function ($$event) {
                                  form.updateFirstName((function (input, value) {
                                          return {
                                                  firstName: value,
                                                  lastName: input.lastName,
                                                  licenseNumber: input.licenseNumber,
                                                  title: input.title,
                                                  bio: input.bio
                                                };
                                        }), $$event.target.value);
                                }),
                              onBlur: (function (param) {
                                  form.blurFirstName();
                                }),
                              value: form.input.firstName,
                              status: form.firstNameResult,
                              labelText: "First name"
                            }),
                        JsxRuntime.jsx(EditMarketingProfileMemberInfoForm$InputField, {
                              onChange: (function ($$event) {
                                  form.updateLastName((function (input, value) {
                                          return {
                                                  firstName: input.firstName,
                                                  lastName: value,
                                                  licenseNumber: input.licenseNumber,
                                                  title: input.title,
                                                  bio: input.bio
                                                };
                                        }), $$event.target.value);
                                }),
                              onBlur: (function (param) {
                                  form.blurLastName();
                                }),
                              value: form.input.lastName,
                              status: form.lastNameResult,
                              labelText: "Last name"
                            }),
                        JsxRuntime.jsx(EditMarketingProfileMemberInfoForm$InputField, {
                              onChange: (function ($$event) {
                                  form.updateTitle((function (input, value) {
                                          return {
                                                  firstName: input.firstName,
                                                  lastName: input.lastName,
                                                  licenseNumber: input.licenseNumber,
                                                  title: value,
                                                  bio: input.bio
                                                };
                                        }), $$event.target.value);
                                }),
                              onBlur: (function (param) {
                                  form.blurTitle();
                                }),
                              value: form.input.title,
                              status: form.titleResult,
                              labelText: "Title"
                            }),
                        (function (__x) {
                              return ReactRender.ifTrue(JsxRuntime.jsx(EditMarketingProfileMemberInfoForm$InputField, {
                                              onChange: (function ($$event) {
                                                  form.updateLicenseNumber((function (input, value) {
                                                          return {
                                                                  firstName: input.firstName,
                                                                  lastName: input.lastName,
                                                                  licenseNumber: value,
                                                                  title: input.title,
                                                                  bio: input.bio
                                                                };
                                                        }), $$event.target.value);
                                                }),
                                              onBlur: (function (param) {
                                                  form.blurLicenseNumber();
                                                }),
                                              value: form.input.licenseNumber,
                                              status: form.licenseNumberResult,
                                              labelText: "License number"
                                            }), __x);
                            })(hasFullProfile),
                        (function (__x) {
                              return ReactRender.ifTrue(JsxRuntime.jsx(EditMarketingProfileMemberInfoForm$BioField, {
                                              form: form
                                            }), __x);
                            })(hasFullProfile)
                      ],
                      className: "space-y-8 border-b border-zinc-200 pb-12 sm:space-y-0 sm:divide-y sm:divide-zinc-200 sm:pb-0"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                              disabled: form.submitting,
                              children: "Save changes"
                            }),
                        JsxRuntime.jsx("div", {
                              children: tmp,
                              role: "status"
                            })
                      ],
                      className: "flex flex-col sm:flex-row gap-4 sm:items-center"
                    })
              ],
              className: "space-y-8",
              onSubmit: (function ($$event) {
                  $$event.preventDefault();
                  form.submit();
                })
            });
}

var make = EditMarketingProfileMemberInfoForm;

exports.Config = Config;
exports.Fragment = Fragment;
exports.Mutation = Mutation;
exports.initialStateFromFragment = initialStateFromFragment;
exports.messageToString = messageToString;
exports.FieldValidationMessage = FieldValidationMessage;
exports.InputField = InputField;
exports.BioField = BioField;
exports.make = make;
/* commitMutation Not a pure module */
